<template>
  <b-overlay :show="loading">
    <form-filter-export @onExport="exportPenerimaanBarang"></form-filter-export>
    <b-card title="Daftar Penerimaan Barang">
      <b-row class="align-items-end mb-1">
        <b-col md="2" sm="6" class="my-1">
          <b-form-group label="Per halaman" label-for="perPageSelect" class="mb-0">
            <b-form-select
              id="perPageSelect"
              v-model="perPage"
              size="sm"
              :options="pageOptions"
            />
          </b-form-group>
        </b-col>
        <b-col md="2" sm="6" class="my-1">
          <b-form-group label="Status" label-for="statusSelect" class="mb-0">
            <b-form-select
              id="statusSelect"
              v-model="selectedStatus"
              size="sm"
              :options="statusOptions"
            />
          </b-form-group>
        </b-col>
        <b-col md="4" sm="6" class="my-1">
          <b-form-group label="Cari" label-for="filterInput" class="mb-0">
            <b-input-group size="sm">
              <b-form-input
                id="filterInput"
                v-model="filter"
                type="search"
                placeholder="Cari no. invoice / keterangan / tanggal..."
                @keyup.enter="applySearch"
              />
              <b-input-group-append>
                <b-button :disabled="!filter" @click="clearSearch">
                  Clear
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col md="4" sm="6" class="my-1 d-flex justify-content-md-end align-items-end">
          <b-button
            v-if="allowCreate() && myGudang"
            variant="primary"
            @click="add()"
          >
            <feather-icon icon="PlusIcon" class="mr-50" />
            Penerimaan Barang
          </b-button>
        </b-col>
      </b-row>

      <b-modal
        v-if="allowCreate() || allowUpdate()"
        v-model="showModal"
        id="modal-penerimaan-barang"
        no-close-on-backdrop
        no-close-on-esc
        centered
        title="Form Penerimaan Barang"
        size="lg"
        hide-footer
      >
        <validation-observer ref="form">
          <div class="d-flex mb-1">
            <feather-icon icon="PackageIcon" size="19" />
            <h6 class="ml-50 mb-0">Penerimaan Barang</h6>
          </div>
          <b-form>
            <b-row>
              <b-col sm="12" md="3">
                <b-form-group label="Pilih Nomor Invoice" label-for="v-jenis">
                  <validation-provider #default="{ errors }" name="jenis" rules="">
                    <b-form-radio-group
                      v-model="form.jenis"
                      :options="options"
                      class="inline-spacing"
                      value-field="value"
                      text-field="text"
                      disabled-field="disabled"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col sm="12" md="3">
                <b-form-group label="No. Invoice" label-for="v-invoice">
                  <validation-provider #default="{ errors }" name="no_invoice" rules="">
                    <b-form-input
                      id="v-invoice"
                      v-model="form.no_invoice"
                      :placeholder="form.jenis == 0 ? 'Isi nomor invoice' : ''"
                      :disabled="form.jenis == 1"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col sm="12" md="6">
                <b-form-group label="Gudang" label-for="gudang">
                  <b-form-select
                    id="gudang"
                    v-model="form.gudang_id"
                    :options="dataGudang"
                    :disabled="user && user.level && user.level.id == 5"
                  />
                </b-form-group>
              </b-col>
              <b-col sm="12" md="6">
                <b-form-group label="Tanggal Penerimaan" label-for="v-tanggal-terima">
                  <validation-provider
                    #default="{ errors }"
                    name="tanggal_penerimaan"
                    rules="required"
                  >
                    <b-form-input
                      id="v-tanggal-terima"
                      v-model="form.tanggal_penerimaan"
                      type="date"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col sm="12" md="6">
                <b-form-group label="Tanggal Invoice" label-for="v-tanggal-inv">
                  <validation-provider
                    #default="{ errors }"
                    name="tanggal_invoice"
                    rules="required"
                  >
                    <b-form-input
                      id="v-tanggal-inv"
                      v-model="form.tanggal_invoice"
                      type="date"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group label="Keterangan (optional)" label-for="v-keterangan">
                  <b-form-textarea
                    id="v-keterangan"
                    v-model="form.keterangan"
                    placeholder="Keterangan"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <div class="d-flex justify-content-end align-items-center mt-2">
              <b-button
                size="sm"
                class="mr-1"
                variant="outline-secondary"
                :disabled="saving"
                @click="showModal = false"
              >
                Batal
              </b-button>
              <b-button
                size="sm"
                variant="primary"
                :disabled="saving"
                @click.prevent="submit"
              >
                <b-spinner v-if="saving" small class="mr-50" />
                {{ saving ? "Menyimpan..." : "Simpan" }}
              </b-button>
            </div>
          </b-form>
        </validation-observer>
      </b-modal>

      <b-row>
        <b-col cols="12">
          <b-table
            small
            striped
            hover
            responsive
            :items="penerimaanBarangs"
            :fields="fields"
            :busy="loading"
          >
            <template #cell(no)="{ index }">
              {{ (currentPage - 1) * perPage + index + 1 }}
            </template>

            <template #cell(no_invoice)="{ item }">
              <div>
                <strong>{{ item.no_invoice || "-" }}</strong>
                <small class="d-block text-muted">
                  Tgl. Inv: {{ humanDate(item.tanggal_invoice) }}
                </small>
                <small class="d-block text-muted">
                  Tgl. Penerimaan: {{ humanDate(item.tanggal_penerimaan) }}
                </small>
              </div>
            </template>

            <template #cell(total_rincian)="{ item }">
              {{ item.total_rincian != null ? item.total_rincian : 0 }}
            </template>

            <template #cell(selesai)="{ item }">
              <b-badge :variant="item.selesai == 1 ? 'success' : 'danger'">
                {{ item.selesai == 1 ? "Selesai" : "Belum ditempatkan" }}
              </b-badge>
            </template>

            <template #cell(actions)="{ item }">
              <div class="d-flex align-items-center">
                <b-button
                  size="sm"
                  variant="warning"
                  class="mr-50"
                  @click="$router.push(`/penerimaan-barang/view/${item.id}`)"
                >
                  <feather-icon icon="EyeIcon" />
                </b-button>
                <b-dropdown
                  v-if="canShowMoreActions(item)"
                  size="sm"
                  variant="link"
                  toggle-class="text-decoration-none p-0"
                  no-caret
                  right
                >
                  <template #button-content>
                    <feather-icon icon="MoreVerticalIcon" size="18" />
                  </template>
                  <b-dropdown-item
                    v-if="canEdit(item)"
                    @click="$router.push(`/penerimaan-barang/edit/${item.id}`)"
                  >
                    Edit
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="canDelete(item)"
                    @click="remove(item)"
                  >
                    Hapus
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </template>
          </b-table>
        </b-col>

        <b-col cols="12">
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="center"
            size="sm"
            class="my-0"
          />
        </b-col>
      </b-row>
    </b-card>
  </b-overlay>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import FormFilterExport from "@core/components/form-filter-export/FormFilterExport.vue";
import {
  BOverlay,
  BModal,
  BTable,
  VBTooltip,
  BCard,
  BBadge,
  BRow,
  BCol,
  BForm,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BFormRadioGroup,
  BFormTextarea,
  BDropdown,
  BDropdownItem,
  BSpinner,
} from "bootstrap-vue";
import mixin from "./mixin";

export default {
  mixins: [mixin],
  components: {
    BForm,
    FormFilterExport,
    BFormRadioGroup,
    ValidationObserver,
    ValidationProvider,
    BCard,
    VBTooltip,
    ToastificationContent,
    BModal,
    BTable,
    BOverlay,
    BFormSelect,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BFormTextarea,
    BDropdown,
    BDropdownItem,
    BSpinner,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  data: () => ({
    loading: false,
    saving: false,
    searchApplied: "",
    selectedStatus: "all",
    statusOptions: [
      { value: "all", text: "Semua" },
      { value: "0", text: "Belum ditempatkan" },
      { value: "1", text: "Selesai" },
    ],
    id: null,
    form: {
      gudang_id: null,
      no_invoice: null,
      jenis: 0,
      tanggal_invoice: null,
      tanggal_penerimaan: null,
      keterangan: null,
    },
    options: [
      { text: "Otomatis", value: "1" },
      { text: "Manual", value: "0" },
    ],
    dataGudang: [],
    perPage: 10,
    pageOptions: [10, 30, 50, 100],
    totalRows: 0,
    currentPage: 1,
    filter: null,
    penerimaanBarangs: [],
    fields: [
      { key: "no", label: "No" },
      { key: "no_invoice", label: "No. Invoice" },
      { key: "total_rincian", label: "Total Item" },
      { key: "selesai", label: "Status" },
      { key: "actions", label: "Aksi" },
    ],
    showModal: false,
  }),
  watch: {
    "form.jenis"(j) {
      if (j == 1) {
        this.getNewNoInvoice();
      } else {
        this.form.no_invoice = null;
      }
    },
    currentPage() {
      this.getPenerimaanBarangs();
    },
    perPage() {
      if (this.currentPage !== 1) {
        this.currentPage = 1;
      } else {
        this.getPenerimaanBarangs();
      }
    },
    selectedStatus() {
      if (this.currentPage !== 1) {
        this.currentPage = 1;
      } else {
        this.getPenerimaanBarangs();
      }
    },
  },
  methods: {
    canEdit(item) {
      return (
        (this.allowUpdate() && item.selesai == 0) ||
        (this.allowUpdate() && !this.isAdminGudang)
      );
    },
    canDelete(item) {
      return (
        (this.allowDelete() && item.selesai == 0) ||
        (this.allowUpdate() && !this.isAdminGudang)
      );
    },
    canShowMoreActions(item) {
      return this.canEdit(item) || this.canDelete(item);
    },
    applySearch() {
      this.searchApplied = this.filter ? String(this.filter).trim() : "";
      if (this.currentPage !== 1) {
        this.currentPage = 1;
      } else {
        this.getPenerimaanBarangs();
      }
    },
    clearSearch() {
      this.filter = "";
      this.searchApplied = "";
      if (this.currentPage !== 1) {
        this.currentPage = 1;
      } else {
        this.getPenerimaanBarangs();
      }
    },
    async exportPenerimaanBarang({ tgl_awal, tgl_akhir, type_export }) {
      if (!tgl_awal || !tgl_akhir) {
        this.displayError({
          message: "Harap isi tanggal awal dan akhir!",
        });
        return false;
      }

      const params = {
        tgl_awal,
        tgl_akhir,
        type_export,
      };

      try {
        this.loading = true;
        const response = await this.doExport(params);
        this.loading = false;
        await window.open(response);
        setTimeout(async () => {
          const arrFile = response.split("/");
          const filename = arrFile[arrFile.length - 1];
          await this.clearExportedFile(filename);
        }, 1000);
      } catch (e) {
        this.loading = false;
        this.displayError(e);
        return false;
      }
    },
    submit() {
      this.$refs.form.validate().then(async (success) => {
        if (!success || this.saving) return;
        if (this.id) {
          this.form.id = this.id;
        }
        if (!this.form.keterangan) {
          this.form.keterangan = "-";
        }
        const payload = this.form;
        try {
          this.saving = true;
          const ajuan = await this.$store.dispatch("penerimaan-barang/save", [
            payload,
          ]);
          this.displaySuccess({
            message: "Penerimaan berhasil disimpan",
          });
          this.showModal = false;
          if (this.id) {
            this.getPenerimaanBarangs();
          } else {
            this.$router.push(`/penerimaan-barang/add/${ajuan.id}`);
          }
        } catch (e) {
          console.error(e);
          this.displayError(e);
          return false;
        } finally {
          this.saving = false;
        }
      });
    },
    getDataGudang() {
      this.$store
        .dispatch("gudang/getData", {
          jenis: 1,
        })
        .then(() => {
          let ter = JSON.parse(JSON.stringify(this.$store.state.gudang.datas));
          const gudangs = [];

          if (this.isAdminGudang) {
            ter.map((gudang) => {
              const itsMyGudang = gudang.id == this.myGudang.id;
              if (itsMyGudang) {
                this.form.gudang_id = this.myGudang.id;
                gudangs.push({
                  value: gudang.id,
                  text: gudang.nama_gudang,
                });
              }
            });
          } else {
            ter.map((item) => {
              gudangs.push({
                value: item.id,
                text: item.nama_gudang,
              });
            });
          }
          this.dataGudang = gudangs;
        });
    },
    async getNewNoInvoice() {
      const noInvoice = await this.$store.dispatch(
        "penerimaan-barang/getNewNoInvoice"
      );
      this.form.no_invoice = noInvoice.message.format;
    },
    add() {
      this.resetForm();
      this.showModal = true;
      this.form.tanggal_penerimaan = this.getCurrentDate();
      this.form.tanggal_invoice = this.getCurrentDate();
      if (this.isAdminGudang && this.myGudang) {
        this.form.gudang_id = this.myGudang.id;
      }
    },
    resetForm() {
      this.id = null;
      this.form = {
        gudang_id:
          this.isAdminGudang && this.myGudang ? this.myGudang.id : null,
        no_invoice: null,
        jenis: 0,
        tanggal_invoice: this.getCurrentDate(),
        tanggal_penerimaan: this.getCurrentDate(),
        keterangan: null,
      };
    },
    remove(item) {
      this.$swal({
        title: "Anda yakin?",
        text: `Data Penerimaan Barang ini akan dihapus`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Ya",
        cancelButtonText: "Batal",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          item.fungsi = 1;
          this.$store
            .dispatch("penerimaan-barang/save", [item])
            .then(() => {
              this.displaySuccess({
                message: "Data berhasil dihapus",
              });
              this.getPenerimaanBarangs();
            })
            .catch((e) => {
              this.displayError(e);
              return false;
            });
        }
      });
    },
    async getPenerimaanBarangs() {
      const params = {
        order: "desc",
        start: (this.currentPage - 1) * this.perPage,
        length: this.perPage,
      };
      if (this.isAdminGudang && !this.isSales && this.myGudang) {
        params.gudang_id = this.myGudang.id;
      }
      if (this.searchApplied) {
        params.search = this.searchApplied;
      }
      if (this.selectedStatus !== "all") {
        params.selesai = Number(this.selectedStatus);
      }

      this.loading = true;
      try {
        const result = await this.$store.dispatch(
          "penerimaan-barang/getData",
          params
        );
        this.penerimaanBarangs = Array.isArray(result) ? result.slice() : [];
        this.totalRows =
          result && result.total != null ? result.total : this.penerimaanBarangs.length;
      } catch (e) {
        this.displayError(e);
        this.penerimaanBarangs = [];
        this.totalRows = 0;
      } finally {
        this.loading = false;
      }
    },
  },
  async created() {
    this.form.tanggal_penerimaan = this.getCurrentDate();
    this.form.tanggal_invoice = this.getCurrentDate();
    await this.getDataGudang();
    await this.getPenerimaanBarangs();
  },
};
</script>
